export default __webpack_public_path__ + "static/media/2.8ed2ec0e.jpg";